import { css } from 'styled-components';
import { UI_BREAKPOINTS } from './breakpoints.types';
// Functions.
// -----------------------------------------------------------------------------
export const breakPointDistance = (from, to) => {
    const indexFrom = UI_BREAKPOINTS.indexOf(from);
    const indexTo = UI_BREAKPOINTS.indexOf(to);
    return indexTo - indexFrom;
};
export const breakpointMax = ({ breakpoint, rules, theme }) => css `
  @media (max-width: ${theme.breakpoints[breakpoint]}px) {
    ${rules}
  }
`;
export const breakpointMin = ({ breakpoint, rules, theme }) => css `
  @media (min-width: ${theme.breakpoints[breakpoint]}px) {
    ${rules}
  }
`;
//# sourceMappingURL=breakpoints.utils.js.map